module.exports = __webpack_public_path__ + "static/header_logo-39085bdc77aba3f288072e46cd1f594f.png";